import { vn } from 'vend-number'
import { isGiftCard } from '../../functions/lineItem'
import { LineItem, UnknownLineItem } from '../../models/line-item'
import { useSaleInventoryData } from '../../ng-compat/hooks'
import { getFeatureFromCache } from '../../util/feature-cache'
import { SaleInventoryData } from '../../components/sale/sale-inventory-data/sale-inventory-data.service'

/**
 * This hook is to determine if a line item in a sale is a special order product
 */
export const useSpecialOrderProduct = () => {
  const saleInventoryData: SaleInventoryData = useSaleInventoryData()

  const isSpecialOrderProduct = (lineItem: LineItem | UnknownLineItem) => {
    const ffEnabled = getFeatureFromCache('inventory_special_orders')

    // ff disabled
    if (!ffEnabled) {
      return false
    }

    // unknown line item
    if (!('fulfilmentType' in lineItem)) {
      return false
    }

    // returned line item
    if (lineItem.isReturn) {
      return false
    }

    // fulfilmentType not pickup or dispatch
    if (
      lineItem.fulfilmentType !== 'PICKUP' &&
      lineItem.fulfilmentType !== 'DISPATCH'
    ) {
      return false
    }

    // gift card
    if (isGiftCard(lineItem.product)) {
      return false
    }

    // quantity <= 0
    const quantity = vn(lineItem.quantity || 0)
    if (quantity.lte(0)) {
      return false
    }

    // composite product
    if (lineItem.product.is_composite) {
      return false
    }

    // item in stock
    /**
     * use hasInventory to check for product in stock
     * hasInventory checks the inventory level against the cumulative quantity of all line items
     * if an item has enough inventory, all split line items are considered in stock (regardless of how they are split)
     * if an item has not enough inventory, all split line items are considered out of stock (regardless of how they are split)
     */
    if (saleInventoryData.hasInventory(lineItem)) {
      return false
    }

    // out of stock product
    return true
  }

  return isSpecialOrderProduct
}
